import { MileageTripInformationFormFragment } from 'generated/resources/graphql'

export const getTripInformationAttributes = (data: MileageTripInformationFormFragment) => {
  const stops = data?.mileage?.mileageStops
    ? [...data.mileage.mileageStops]
        .sort((a, b) => a.position - b.position)
        .map((stop) => ({
          name: stop.name ?? '',
          latitude: stop.latitude != null ? String(stop.latitude) : null,
          longitude: stop.longitude != null ? String(stop.longitude) : null,
        }))
    : []

  return {
    to: data?.mileage?.to,
    from: data?.mileage?.from,
    originLatitude: data?.mileage?.originLatitude,
    originLongitude: data?.mileage?.originLongitude,
    destinationLatitude: data?.mileage?.destinationLatitude,
    destinationLongitude: data?.mileage?.destinationLongitude,
    stops,
  }
}
